import React from 'react'
import './App.css'
import './Main.scss'
import './styles/styles.scss'
import './styles/flexbox.css'

import Toolbar from './containers/Toolbar'
import Navbar from './containers/Navbar'
import GenericError from 'containers/GenericError'
import { NavTop } from './containers/Navbar/navTop';
import { PopupProvider } from './components/GlobalPopup';

type MainProps = React.PropsWithChildren<{}>;

const Main: React.FC<MainProps> = ({children}) => {
  return (
    <PopupProvider>
      <div className="page">
        <Toolbar />
        <div className="main">
            <div className="navbar-top">
              <NavTop />
            </div>
            <div className="navbar">
              <Navbar />
            </div>
          <GenericError />
          <div className="content">{children}</div>
        </div>
      </div>
    </PopupProvider>
  )
}

export default Main
